const TableSize = ({ size, onChange }) => {
  return (
    <div className="p-4">
      <p className="text-sm text-gray-400 mb-4">Size</p>
      <select className="form-control" defaultValue={size} onChange={onChange}>
        <option>10</option>
        <option>25</option>
        <option>50</option>
        <option>100</option>
        <option>300</option>
        <option>1000</option>
        <option>2000</option>
      </select>
    </div>
  );
};

export default TableSize;
